export const prodDomainName = 'upgradehealth.com'
export const prodAxoDomainName = 'axo.health'